import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Law } from "../../models/models";
import { Observable } from "rxjs";
import { LawService } from "../../services/law.service";
import { Injectable } from "@angular/core";

@Injectable()
export class LawLibraryViewResolver  {

    constructor(public lawService: LawService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Law> {
        return this.lawService.getLaw(route.paramMap.get('id'));
    }
}

